/**
 * @typedef {Object} FormData
 * @property {string} activity
 * @property {string} reason
 * @property {number} shareholders
 * @property {number} visas
 * @property {string} office
 * @property {string} jurisdiction
 * @property {string} inUAE
 * @property {string} timeline
 */

export const INITIAL_FORM_DATA = {
  activity:     "",
  reason:       "",
  shareholders: 1,
  visas:        1,
  office:       "",
  jurisdiction: "",
  inUAE:        "",
  timeline:     "",
};
